import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import P8 from "../images/csca.jpg"; // 2024-25 image
import P9 from "../images/csca2025_26.jpg"; // new image for 2025-26
import { useEffect, useState } from "react";

function Csca() {
  const Urlmain = "https://gcbeetan.co.in/admin/uploads/";
  const [user, setUser] = useState([]);
  const fetchData = () => {
    return fetch("https://gcbeetan.co.in/admin/api/api.php/notifications/csca")
          .then((response) => response.json())
          .then((data) => setUser(data));
  }
  useEffect(() => {
    fetchData();
  },[])

  return (
    <>
      <Header />
      <section
        className="content-section title-top"
        style={{ backgroundImage: `url(${topback})` }}
      >
        <div className="pattern-overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 title-heading">
                <h2>CSCA</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- section --> */}
      <div className="section margin-top_50">
        <div className="container mb-5 pb-5">
          {/* CSCA 2025-26 */}
          <div className="row mb-5">
            <div className="col-md-4">
              <div className="full mt-5">
                <img src={P9} alt="CSCA 2025-26" />
              </div>
            </div>
            <div className="col-md-8 layout_padding_2">
              <h3>CSCA 2025-26</h3>
              <p>
                CSCA for the session 2025-2026 on the basis of academic merit and
                nominations in r/o S.D.W.G. GOVT.COLLEGE BEETAN. The detail of the CSCA
                office bearers is as under:
              </p>
              <table className="table">
                <thead>
                  <tr>
                    <th>Post</th>
                    <th>Name</th>
                    <th>Class</th>
                    <th>Roll No.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>President</td>
                    <td>Chirag</td>
                    <td>B.Sc 3<sup>rd</sup> yr</td>
                    <td>2232570002</td>
                  </tr>
                  <tr>
                    <td>Vice-President</td>
                    <td>Ritika</td>
                    <td>M.A English 1<sup>st</sup> sem</td>
                    <td>MAENG001</td>
                  </tr>
                  <tr>
                    <td>Secretary</td>
                    <td>Sukhjeet</td>
                    <td>B.A 1<sup>st</sup> yr</td>
                    <td>25HIS012</td>
                  </tr>
                  <tr>
                    <td>Joint Secretary</td>
                    <td>Simran</td>
                    <td>B.Com 1<sup>st</sup> yr</td>
                    <td>25BCM012</td>
                  </tr>
                </tbody>
              </table>
              <h6>Committee Members:</h6>
              <p>1. Dr. Uma Rani</p>
              <p>2. Dr. Gaurav Sharma</p>
              <p>3. Dr. Richa Sharma</p>
              <p>4. Prof. Anita Devi</p>
              <div className="full mt-4">
            <div className="about-principal">
              <p>
                <strong>Principal Dr. Sunita Goyal</strong>
              </p>
              <p>
                <strong> with CSCA Office Bearers 2025-26</strong>
              </p>
              <p>
              </p>
            </div>
          </div>
            </div>
          </div>
          

          {/* CSCA 2024-25 */}
          <div className="row mb-5">
            <div className="col-md-4">
              <div className="full mt-5">
                <img src={P8} alt="CSCA 2024-25" />
              </div>
            </div>
            <div className="col-md-8 layout_padding_2">
              <h3>CSCA 2024-25</h3>
              <p>
                CSCA for the session 2024-2025 on the basis of academic merit and
                nominations in r/o SDWG GOVT.COLLEGE BEETAN. The detail of the CSCA
                office bearers is as under:
              </p>
              <table className="table">
                <thead>
                  <tr>
                    <th>Post</th>
                    <th>Name</th>
                    <th>Roll No.</th>
                    <th>Class</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>President</td>
                    <td>Riya</td>
                    <td>1222570032</td>
                    <td>B.A.3rd Year</td>
                  </tr>
                  <tr>
                    <td>Vice President</td>
                    <td>Chirag</td>
                    <td>2232570002</td>
                    <td>B.Sc 2nd Year</td>
                  </tr>
                  <tr>
                    <td>Secretary</td>
                    <td>Mansi</td>
                    <td>1232570018</td>
                    <td>B.A.2nd Year</td>
                  </tr>
                  <tr>
                    <td>Joint Secretary </td>
                    <td>Kanika</td>
                    <td>24BCM013</td>
                    <td>B.COM 1st Year </td>
                  </tr>
                </tbody>
              </table>
              <h6>Committee Members:</h6>
              <p>1. Prof. Gurdev Singh</p>
              <p>2. Dr Uma Rani</p>
              <p>3. Dr Gaurav Sharma</p>
              <p>4. Dr Daleep Bali</p>
              <p>5. Prof Richa Sharma</p>
              <div className="full mt-4">
            <div className="about-principal">
              <p>
                <strong>Dr. Sunita Goyal</strong>
              </p>
              <p>
                <strong>Principal SDWG Govt. College Beetan</strong>
              </p>
              <p>
                <strong>Distt. Una H.P.</strong>
              </p>
            </div>
          </div>
            </div>
          </div>

          

          {/* Commented-out section for future dynamic fetch */}
          { <div className="show-list mt-5 pb-5">
            <ul>
              {user &&
                user.length > 0 &&
                user.map((userObj, index) => (
                  <li key={index}>
                    <i className="fa fa-check-circle"></i>
                    <a
                      href={Urlmain + userObj.myfile}
                      className="list-inner"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {userObj.title}
                    </a>
                  </li>
                ))}
            </ul>
          </div> }
        </div>
      </div>
      {/* <!-- end section --> */}
      <Footer />
    </>
  );
}

export default Csca;
